import { Add, Remove } from '@mui/icons-material'
import { IconButton, Stack, Typography } from '@mui/material'

import React from 'react'

type Props = {
  quantity: number
  size?: 'small' | 'medium' | 'large'
  onChange?: (newValue: number) => void
  min?: number
  max?: number | null
  disabled?: boolean
}

const QuantitySelectV2: React.FC<Props> = ({
  quantity,
  size = 'medium',
  min = 0,
  max,
  disabled,
  onChange = () => {},
}) => {
  return (
    <Stack
      alignItems="center"
      direction="row"
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 10,
      }}>
      <IconButton
        data-cy="item-quantity-decrease"
        disabled={disabled || quantity === min}
        size={size}
        onClick={() => onChange(quantity - 1)}>
        <Remove fontSize={size} />
      </IconButton>

      <Typography
        fontSize={size}
        textAlign="center"
        minWidth="2em"
        variant="body2"
        sx={{
          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderColor: 'divider',
          paddingY: size === 'small' ? 0.5 : size === 'large' ? 1.5 : 1,
          paddingX: size === 'small' ? 1 : size === 'large' ? 3.5 : 2.5,
        }}>
        {quantity}
      </Typography>
      <IconButton
        data-cy="item-quantity-increase"
        disabled={disabled || Boolean(typeof max === 'number' && quantity === max)}
        size={size}
        onClick={() => onChange(quantity + 1)}>
        <Add fontSize={size} />
      </IconButton>
    </Stack>
  )
}

export default QuantitySelectV2
